import { and, employee, qantSmsEnabled } from '../condition.js';
import type { ProductMenuDef } from '../type.js';

/** Debeso（外部連携機能）のグローバルナビゲーション定義。 */
export const QANT_DEBESO_MENU = {
  product: {
    name: 'debeso',
    icon: 'qantDebeso',
    label: { ja: '外部連携機能', en: 'External integrations' },
    description: { ja: '外部サービスとの接続・クローラー', en: 'External service connections and crawlers' },
  },
  menuGroups: {
    INTEGRATIONS: {
      name: 'integrations',
      label: { ja: '外部連携', en: 'External integrations' },
      menus: {
        INTEGRATIONS: {
          name: 'integrations',
          icon: 'integration',
          label: { ja: '外部連携', en: 'External integrations' },
          path: { host: 'qant', path: '/debeso/external-apis' },
        },
      },
    },
    CRAWLING: {
      name: 'crawling',
      label: { ja: 'クローラー', en: 'Crawlers' },
      menus: {
        CRAWLERS: {
          name: 'crawlers',
          icon: 'list',
          label: { ja: 'クローラー', en: 'Crawlers' },
          path: { host: 'qant', path: '/debeso/crawlers' },
          options: { adminUi: true },
          condition: employee(),
        },
        DEPLOYMENTS: {
          name: 'deployments',
          icon: 'jobFlow',
          label: { ja: 'デプロイメント', en: 'Deployments' },
          path: { host: 'qant', path: '/debeso/deployments' },
          options: { adminUi: true },
          condition: employee(),
        },
        SETTINGS: {
          name: 'settings',
          icon: 'settings',
          label: { ja: '実行設定', en: 'Execution settings' },
          path: { host: 'qant', path: '/debeso/settings' },
          options: { adminUi: true },
          condition: employee(),
        },
        TASKS: {
          name: 'tasks',
          icon: 'jobFlow',
          label: { ja: '実行履歴', en: 'Execution history' },
          path: { host: 'qant', path: '/debeso/tasks' },
          options: { adminUi: true },
          condition: employee(),
        },
      },
    },
    COLLECTOR: {
      name: 'collector',
      label: { ja: 'コレクター', en: 'Collector' },
      menus: {
        COLLECTOR_SETTINGS: {
          name: 'collectorSettings',
          icon: 'settings',
          label: { ja: 'Collector 設定', en: 'Collector settings' },
          path: { host: 'qant', path: '/debeso/collector-settings' },
          options: { adminUi: true },
          condition: employee(),
        },
      },
    },
    SMS: {
      name: 'sms',
      label: { ja: 'SMS', en: 'SMS' },
      menus: {
        SMS_HUB: {
          name: 'smsHub',
          icon: 'smsSettings',
          label: { ja: 'SMS設定', en: 'SMS settings' },
          condition: qantSmsEnabled(),
          popoverMenus: {
            MAIN: {
              name: 'main',
              items: {
                SMS_LOGS: {
                  name: 'smsLogs',
                  label: { ja: 'SMS送信履歴', en: 'SMS message history' },
                  path: { host: 'qant', path: '/debeso/sms/logs' },
                  condition: qantSmsEnabled(),
                },
                SMS_URL: {
                  name: 'smsUrl',
                  label: { ja: '短縮URL', en: 'Short URLs' },
                  path: { host: 'qant', path: '/debeso/sms/url' },
                  condition: qantSmsEnabled(),
                },
                SMS_ADMIN_SETTINGS: {
                  name: 'smsAdminSettings',
                  label: { ja: '管理者設定', en: 'Admin settings' },
                  path: { host: 'qant', path: '/debeso/sms/settings' },
                  options: { adminUi: true },
                  condition: and(qantSmsEnabled(), employee()),
                },
                SMS_SEND_TEST: {
                  name: 'smsSendTest',
                  label: { ja: '送信テスト', en: 'Send test' },
                  path: { host: 'qant', path: '/debeso/sms/sendTest' },
                  options: { adminUi: true },
                  condition: and(qantSmsEnabled(), employee()),
                },
              },
            },
          },
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
